import { memo, forwardRef, useImperativeHandle, useRef } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJUsageDetailTwo from '../view/FJUsageDetailTwo.jsx';
import useUsageDetailContainer from '../../../../hooks/useUsageDetailContainer.jsx';

const FJUsageDetailTwoContainer = memo(
    forwardRef((props, ref) => {
        const { renderTrigger, offsetLeft, offsetTop, placement } = props;
        useLocalStore();
        const { list, totalCredit } = useUsageDetailContainer();

        const dropDownRef = useRef(null);

        // 定义要暴露给父组件的方法
        useImperativeHandle(ref, () => ({
            // 这里可以添加想要暴露的方法
            show: () => {
                dropDownRef.current?.openDropdown();
            },
            hide: () => {
                dropDownRef.current?.closeDropdown();
            },
        }));

        return (
            <FJUsageDetailTwo
                ref={dropDownRef}
                list={list}
                totalCredit={totalCredit}
                renderTrigger={renderTrigger}
                offsetLeft={offsetLeft}
                offsetTop={offsetTop}
                placement={placement}
            />
        );
    }),
);

export default FJUsageDetailTwoContainer;
